(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sowpeace-offers"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',async(event)=>{
   const copy=event.target.closest('[data-sp-copy]');
   if(copy){const status=copy.closest('[data-offers]')?.querySelector('[data-offer-status]');try{await navigator.clipboard.writeText(copy.dataset.spCopy);copy.dataset.copied='true';copy.querySelector('span').textContent='Copied';if(status)status.textContent='Code '+copy.dataset.spCopy+' copied. Enter it at checkout.';}catch{if(status)status.textContent='Select and copy the displayed code to use at checkout.';}return;}
   const step=event.target.closest('[data-offer-step]');if(step){const rail=step.closest('[data-offers]').querySelector('.sp-offers-track');rail.scrollBy({left:Number(step.dataset.offerStep)*(rail.clientWidth+10),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
 });
  } catch(e) { console.error(e); }
})();

})();
